import { render, staticRenderFns } from "./RequestsTable.vue?vue&type=template&id=c88c1222&"
import script from "./RequestsTable.vue?vue&type=script&lang=js&"
export * from "./RequestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports